module.exports = __webpack_public_path__ + "img/Lesego Lehong.04e47fdd.png";